<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <!-- Header con detalles del trámite -->
        <div class="card-header" style="background-color: #DBECDB;">
          <div class="row">
            <div class="col-md-6">
              <div class="card mt-3">
                <div class="card-header">
                  <h6 class="card-title">Detalles del Trámite: - 
                    {{
                      tramite.tipo_etapa == 1 ? 'Común' :
                      tramite.tipo_etapa == 2 ? 'Legal' :
                      tramite.tipo_etapa == 3 ? 'Dirección' :
                      tramite.tipo_etapa == 4 ? 'Venta de valores' :
                      tramite.tipo_etapa == 5 ? 'MINEDU' :
                      'Desconocido'
                    }}</h6> 
                  {{ tramite.tipo }} 
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-xs table-bordered table-striped" style="font-size: 0.8em;">
                      <thead>
                        <tr>
                          <th style="text-align: right;">Código:</th>
                          <td>{{ tramite.codigo }}</td>
                        </tr>
                        <tr>
                          <th style="text-align: right;">Solicitante:</th>
                          <td>{{ tramite.nombres }} {{ tramite.paterno }} {{ tramite.materno }}</td>
                        </tr>
                        <tr>
                          <th style="text-align: right;">Unidad:</th>
                          <td>
                            {{ tramite.codigo_unidad }} - {{ tramite.nombre_unidad }}
                          </td>
                        </tr>
                        <tr>
                          <th style="text-align: right;">Seccion:</th>
                          <td>
                            {{ tramite.codigo_area }} - {{ tramite.nombre_area }}
                          </td>
                        </tr>
                      </thead>
                    </table>
                    <table class="table table-sm table-bordered table-striped" style="font-size: 0.8em;">
                      <thead>
                        <tr>
                          <th colspan="2" style="text-align: right;">Costos del Tramite:</th>
                        </tr>
                        <tr>
                          <td style="text-align: right;">DDE-Beni:</td>
                          <td>{{ tramite.costo }}</td>
                        </tr>
                        <tr>
                          <td style="text-align: right;">Min. Educacion:</td>
                          <td>{{ tramite.costo_minedu }}</td>
                        </tr>
                        <tr v-for="valorado in valorados" 
                                :key="valorado.id" 
                                :value="valorado.id_valorado">
                          <td style="text-align: right;">{{ valorado.descripcion }}:</td>
                          <td>
                            {{ valorado.costo }}
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: right;"><strong>Costo Total:</strong></td>
                          <td><strong>{{ totales.costo_total }}</strong></td>
                        </tr>
                      </thead>
                    </table>      
                  </div>
                </div>
              </div>
              
            </div>
            <div class="col-md-6">
              <div class="card mt-3">
                <div class="card-header">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="card-title">Estado del Tramite</h6>
                    <BButton
                      variant="danger"
                      class="btn-round btn-sm"
                      @click="generateFormPDF(tramite.id)"
                    >
                      <i class="fa fa-file-pdf me-1"></i> Form. Tramite
                    </BButton>
                    <BButton
                      v-if="ShowButton"
                      @click="derivarTramite(tramite.id)"
                      variant="success"
                      class="btn-round btn-sm"
                    >
                      <i class="fa fa-arrow-right me-1"></i> Derivar
                    </BButton>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered table-striped" style="font-size: 0.8em;">
                      <thead>
                        <tr>
                          <th>Etapa</th>
                          <th>Estado</th>
                          <th>Fecha</th>
                          <th>Responsable</th>
                          <th>Observacion</th>
                        </tr>
                        <tr v-for="etapa in etapas" 
                          v-show="!((etapa.etapa === 'Inicio' || etapa.etapa === 'Legal' || etapa.etapa === 'Firma' || etapa.etapa === 'Archivo') && etapa.estado === 'Recibido')">
                          <th style="text-align: right;">{{ etapa.etapa }}</th>
                          <td>
                            <span v-if="(etapa.etapa === 'Inicio' || etapa.etapa === 'Legal' || etapa.etapa === 'Firma') && etapa.estado === 'Aprobado'">
                              Aceptado
                            </span>
                            <span v-else>
                              {{ etapa.estado }}
                            </span>
                          </td>
                          <td>{{ etapa.fecha }}</td>
                          <td>{{ etapa.etapa=='Entrega' && etapa.estado=='Entregado'? etapa.nombres + ' ' + etapa.paterno : etapa.usuario_registro }}</td>
                          <td>{{ etapa.observacion }}</td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
                  
              
            </div>
          </div>
        </div>
        
        <!-- Body con requisitos y depósitos -->
        <div class="card-body">
          <div class="row">
            <!-- Requisitos -->
            <div class="col-md-5">
              <div class="card">
                <div class="card-header">
                  <h6 class="card-title">Requisitos</h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                      <thead style="line-height: 8px;">
                        <tr>
                          <th>Descripción</th>
                          <th>Completado</th>
                          <th v-if="ShowButton">Accion</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="requisito in requisitos" :key="requisito.id">
                          <td>{{ requisito.descripcion }}</td>
                          <td>
                            <BBadge :variant="requisito.id_requisito ? 'success' : 'secondary'">
                              {{ requisito.id_requisito ? 'SI' : 'NO' }}
                            </BBadge>
                          </td>
                          <td v-if="ShowButton">
                              <BButton
                                v-if="!requisito.id_requisito && ShowButton"
                                @click="marcarRequisito(requisito.id)"
                                variant="success"
                                size="sm"
                              >
                                <i class="fa fa-check"></i>
                              </BButton>
                              <BButton
                                v-if="requisito.id_requisito && ShowButton"
                                @click="eliminarRequisito(requisito.id)"
                                variant="danger"
                                size="sm"
                              >
                                <i class="fa fa-times"></i>
                              </BButton>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Depósitos -->
            <div class="col-md-7">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="card-title">Depósitos</h6>
                    <BButton
                      v-if="ShowButton"
                      @click="showDepositoModal(null)"
                      variant="primary"
                      class="btn-round btn-sm"
                    >
                      <i class="fa fa-plus me-1"></i> Nuevo Depósito
                    </BButton>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                      <thead style="line-height: 10px;">
                        <tr>
                          <th>N° Depósito</th>
                          <th>Monto</th>
                          <th>Fecha</th>
                          <th>Cuenta</th>
                          <th>Canjeado</th>
                          <th>Saldo</th>
                          <th v-if="ShowButton">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="deposito in depositos" :key="deposito.id">
                          <td>{{ deposito.nro_deposito }}</td>
                          <td>{{ deposito.monto }}</td>
                          <td>{{ formatDate(deposito.fecha_deposito) }}</td>
                          <td>{{ deposito.destino }}</td>
                          <td>{{ deposito.total_canje }}</td>
                          <td>{{ deposito.saldo }}</td>
                          <td v-if="ShowButton">
                            <div class="btn-group">
                              <BButton
                                v-if="ShowButton"
                                @click="showCambioDepositoModal(deposito)"
                                variant="info"
                                size="sm"
                                class="me-1"
                              >
                                <i class="fa fa-exchange-alt"></i>
                              </BButton>
                              <BButton
                                v-if="ShowButton"
                                @click="confirmDeleteDeposito(deposito)"
                                variant="danger"
                                size="sm"
                              >
                                <i class="fa fa-trash"></i>
                              </BButton>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  <div class="mt-3">
                    <div class="alert" :class="{
                      'alert-success': totalDepositos === costoTotal,
                      'alert-warning': totalDepositos < costoTotal && totalDepositos > 0,
                      'alert-danger': totalDepositos === 0
                    }">
                      <strong>Total depositado:</strong> {{ totales.total_dep }}
                    </div>
                  </div>
                  
                  <!-- Cambios de depósito -->
                  <div class="card mt-3" v-if="cambiosDepositos.length > 0">
                    <div class="card-header">
                      <h6 class="card-title">Canje de Depósito</h6>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive">
                        <table class="table table-sm table-striped table-hover" style="font-size: 0.8em;">
                          <thead style="line-height: 10px;">
                            <tr>
                              <th>N°.Depósito</th>
                              <th>Valorado</th>
                              <th>N°.Val.</th>
                              <th>Destino</th>
                              <th>Monto</th>
                              <th v-if="ShowButton">Accion</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="cambio in cambiosDepositos" :key="cambio.id">
                              <td>{{ cambio.nro_deposito }}</td>
                              <td>{{ !cambio.descripcion?'por tramite':cambio.descripcion  }}</td>
                              <td>{{ cambio.serie }}-{{ cambio.numero }}</td>
                              <td>{{ cambio.destino }}</td>
                              <td>{{ cambio.monto }}</td>
                              <td v-if="ShowButton">
                                <div class="btn-group">
                                  <BButton
                                    v-if="ShowButton"
                                    @click="confirmDeleteDepositoCambio(cambio)"
                                    variant="danger"
                                    size="sm"
                                  >
                                    <i class="fa fa-trash"></i>
                                  </BButton>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal para Depósitos -->
    <BModal
      v-model="depositoModalVisible"
      :title="depositoModalTitle"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleDepositoSubmit">
        <div class="row mt-0">
          <table class="table table-bordered" >
            <tr>
              <th style="border: 1px solid #c3c3c3;"></th>
              <th style="border: 1px solid #c3c3c3;">DDE-Beni</th>
              <th style="border: 1px solid #c3c3c3;">Valorado</th>
              <th style="border: 1px solid #c3c3c3;">Min.Edu.</th>
            </tr>
            <tr>
              <td style="border: 1px solid #c3c3c3;">Costos</td>
              <td style="border: 1px solid #c3c3c3;">{{ tramite.costo }}</td>
              <td style="border: 1px solid #c3c3c3;">{{ totales.total_val }}</td>
              <td style="border: 1px solid #c3c3c3;">{{ tramite.costo_minedu }}</td>
            </tr>
          </table>
        </div>
        <div class="row mt-2">
          <label class="form-label col-md-3  text-end">N° Depósito:</label>
          <div class="form-group col-md-9">
            <input
              v-model="depositoForm.nro_deposito"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': depositoErrors.nro_deposito }"
              required
            />
            <div class="invalid-feedback" v-if="depositoErrors.nro_deposito">
              {{ depositoErrors.nro_deposito[0] }}
            </div>
          </div>
        </div>
        
        <div class="row mt-3">
          <label class="form-label col-md-3 text-end">Monto</label>
          <div class="form-group col-md-9">
            <input
              v-model="depositoForm.monto"
              type="number"
              step="0.00"
              class="form-control"
              :class="{ 'is-invalid': depositoErrors.monto }"
              required
            />
            <div class="invalid-feedback" v-if="depositoErrors.monto">
              {{ depositoErrors.monto[0] }}
            </div>
          </div>
        </div>
        
        <div class="row mt-3">
          <label class="form-label col-md-3 text-end">Fecha:</label>
          <div class="form-group col-md-9">
            <input
              v-model="depositoForm.fecha"
              type="date"
              class="form-control"
              :class="{ 'is-invalid': depositoErrors.fecha }"
              required
            />
            <div class="invalid-feedback" v-if="depositoErrors.fecha">
              {{ depositoErrors.fecha[0] }}
            </div>
          </div>
        </div>
        
        <div class="row mt-3">
          <label class="form-label col-md-3 text-end">Cuenta:</label>
          <div class="form-group col-md-9">
            <select
              v-model="depositoForm.destino"
              class="form-select"
              :class="{ 'is-invalid': depositoErrors.destino }"
              required
            >
              <option value="dde">Cuenta DDE</option>
              <option value="minedu">Cuenta MINEDU</option>
            </select>
            <div class="invalid-feedback" v-if="depositoErrors.destino">
              {{ depositoErrors.destino[0] }}
            </div>
          </div>
        </div>
        
        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="depositoModalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingDepositoForm"
          >
            <span v-if="loadingDepositoForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditingDeposito ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
    
    <!-- Modal para Cambios de Depósito -->
    <BModal
      v-model="cambioDepositoModalVisible"
      title="Registrar Cange de Depósito"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleCambioDepositoSubmit">
        <div class="row mt-3">
          <label class="form-label col-md-3 text-end">Tipo:</label>
          <div class="form-group col-md-9">
            <select
              v-model="cambioDepositoForm.tipo"
              class="form-select"
              @change="handleTipoChange"
              required
            >
              <option value="valorado">Valorado</option>
              <option value="servicio">Servicio</option>
              <option value="valorado_multiple">Valorado Múltiple</option>
            </select>
          </div>
        </div>
        
        <div class="row mt-3" v-if="cambioDepositoForm.tipo !== 'servicio'">
          <label class="form-label col-md-3 text-end">Valorado:</label>
          <div class="form-group col-md-9">
            <select
              v-model="cambioDepositoForm.id_valorado"
              class="form-select"
              :class="{ 'is-invalid': cambioDepositoErrors.id_valorado }"
              @change="cargarDetalleValorado"
              required
            >
              <option value="">-- seleccione Valorado --</option>
              <option 
                v-for="valorado in valorados" 
                :key="valorado.id" 
                :value="valorado.id_valorado"
              >
                {{ valorado.descripcion }} ({{ valorado.costo }})
              </option>
            </select>
            <div class="invalid-feedback" v-if="cambioDepositoErrors.id_valorado">
              {{ cambioDepositoErrors.id_valorado[0] }}
            </div>
          </div>
        </div>
        
        <div class="row mt-3" v-if="cambioDepositoForm.tipo == 'servicio'">
          <label class="form-label col-md-3 text-end">Cantidad:</label>
          
          <div class="form-group col-md-9" v-if="cambioDepositoForm.tipo === 'servicio'">
            <input
              v-model="cambioDepositoForm.cantidad"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': cambioDepositoErrors.cantidad }"
              required
            />
            <div class="invalid-feedback" v-if="cambioDepositoErrors.cantidad">
              {{ cambioDepositoErrors.cantidad[0] }}
            </div>
          </div>
        </div>
        
        <div class="row mt-3" v-if="cambioDepositoForm.tipo != 'servicio'">
          <label class="form-label col-md-2 text-end">Serie:</label>
          <div class="form-group col-md-3">
            <select
              v-model="cambioDepositoForm.serie"
              class="form-select"
              required
            >
              <option v-for="letra in series" :value="letra">{{ letra }}</option>
            </select>
            <div class="invalid-feedback" v-if="cambioDepositoErrors.serie">
              {{ cambioDepositoErrors.serie[0] }}
            </div>
          </div>
          
          <label v-if="cambioDepositoForm.tipo === 'valorado'" class="form-label col-md-3 text-end">N° Valorado:</label>
          <div class="form-group col-md-4" v-if="cambioDepositoForm.tipo === 'valorado'">
            <input
              v-model="cambioDepositoForm.numero"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': cambioDepositoErrors.numero }"
              required
            />
            <div class="invalid-feedback" v-if="cambioDepositoErrors.numero">
              {{ cambioDepositoErrors.numero[0] }}
            </div>
          </div>
          
        </div>

        <div class="row mt-3" v-if="cambioDepositoForm.tipo === 'valorado_multiple'">
          <label class="form-label col-md-3 text-end">N° Desde:</label>
          <div class="form-group col-md-3">
            <input
              v-model="cambioDepositoForm.numero_desde"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': cambioDepositoErrors.numero_desde }"
              required
            />
            <div class="invalid-feedback" v-if="cambioDepositoErrors.numero_desde">
              {{ cambioDepositoErrors.numero_desde[0] }}
            </div>
          </div>
          <label class="form-label col-md-3 text-end">N° Hasta:</label>
          <div class="form-group col-md-3">
            <input
              v-model="cambioDepositoForm.numero_hasta"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': cambioDepositoErrors.numero_hasta }"
              required
            />
            <div class="invalid-feedback" v-if="cambioDepositoErrors.numero_hasta">
              {{ cambioDepositoErrors.numero_hasta[0] }}
            </div>
          </div>
        </div>
        
        <div class="row mt-3">
          <label class="form-label col-md-3 text-end">Monto:</label>
          <div class="form-group col-md-9">
            <input
              v-model="cambioDepositoForm.monto"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': cambioDepositoErrors.monto }"
              required
            />
            <div class="invalid-feedback" v-if="cambioDepositoErrors.monto">
              {{ cambioDepositoErrors.monto[0] }}
            </div>
            <small class="text-muted">Monto disponible: {{ depositoSeleccionado ? depositoSeleccionado.monto : 0 }}</small>
          </div>
        </div>
        <div class="modal-footer mt-3 ">
          <BButton
            type="button"
            variant="secondary"
            @click="cambioDepositoModalVisible = false"
            class="me-2"
          >
			      Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingCambioDepositoForm"
          >
            <span v-if="loadingCambioDepositoForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Guardar
          </BButton>
        </div>
      </form>
    </BModal>

    <!-- Modal para Resumen de Derivación -->
    <BModal
      v-model="resumenDerivacionVisible"
      title="Resumen del Trámite"
      size="xl"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <div class="alert alert-sm alert-danger" v-if="erroresDerivacion.length && tramite.tipo_etapa != 4">
        <h5>No se puede derivar el trámite:</h5>
        <ul>
          <li v-for="(error, index) in erroresDerivacion" :key="index">{{ error }}</li>
        </ul>
      </div>

      <div class="row">
        <!-- Resumen de Requisitos -->
        <div class="col-md-6">
          <div class="card card-sm">
            <div class="card-header bg-info text-white">
              <h6 class="card-title">Requisitos</h6>
            </div>
            <div class="card-body">
              <table class="table table-sm">
                  <tr v-for="requisito in requisitos" :key="requisito.id">
                    <td>{{ requisito.descripcion }}</td>
                    <td>
                      <BBadge :variant="requisito.id_requisito ? 'success' : 'danger'">
                        {{ requisito.id_requisito ? 'COMPLETO' : 'FALTANTE' }}
                      </BBadge>
                    </td>
                  </tr>
              </table>
            </div>
          </div>
          
        </div>

        <!-- Resumen de Costos y Depósitos -->
        <div class="col-md-6">
          <div class="card card-sm">
            <div class="card-header bg-info text-white">
              <h6 class="card-title">Finanzas</h6>
            </div>
            <div class="card-body">
              <h6 class="card-title">Costos del Trámite:</h6>
              <table class="table table-sm" style="font-size: 0.8rem;">
                <tr>
                  <td>DDE-Beni:</td>
                  <td class="text-end">{{ tramite.costo }}</td>
                </tr>
                <tr>
                  <td>Min. Educación:</td>
                  <td class="text-end">{{ tramite.costo_minedu }}</td>
                </tr>
                <tr v-for="valorado in valorados" :key="valorado.id">
                  <td>{{ valorado.descripcion }}:</td>
                  <td class="text-end">{{ valorado.costo }}</td>
                </tr>
                <tr class="table-primary" v-if="tramite.tipo_etapa != 4">
                  <td><strong>TOTAL COSTO:</strong></td>
                  <td class="text-end"><strong>{{ totales.costo_total }}</strong></td>
                </tr>
              </table>
              <table class="table table-sm" style="font-size: 0.8rem;">
                <tfoot>
                  <tr class="table-info">
                    <td colspan="2"><strong>TOTAL DEPOSITADO:</strong></td>
                    <td class="text-end"><strong>{{ totales.total_dep }}</strong></td>
                  </tr>
                  <tr class="table-info">
                    <td colspan="2"><strong>TOTAL CANJEADO:</strong></td>
                    <td class="text-end"><strong>{{ totalCanjeado }}</strong></td>
                  </tr>
                  <tr :class="saldoDeposito >= 0 ? 'table-success' : 'table-danger'">
                    <td colspan="2"><strong>SALDO:</strong></td>
                    <td class="text-end"><strong>{{ saldoDeposito }}</strong></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer mt-3">
        <BButton
          variant="secondary"
          @click="resumenDerivacionVisible = false"
          class="me-2"
        >
          Cancelar
        </BButton>
        <BButton v-if="tramite.tipo_etapa != 4"
          variant="primary"
          @click="confirmarDerivacion"
          :disabled="erroresDerivacion.length > 0"
        >
          <i class="fa fa-check me-1"></i> Confirmar Derivación
        </BButton>
        <BButton v-if="tramite.tipo_etapa == 4"
          variant="primary"
          @click="confirmarDerivacionVenta"
        >
          <i class="fa fa-check me-1"></i> Confirmar Derivación
        </BButton>
      </div>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import { BModal, BButton, BBadge } from 'bootstrap-vue-3';
import Swal from 'sweetalert2';

interface Tramite {
  id: number;
  codigo: string;
  id_solicitante: string;
  id_tipotramite: number;
  recepcion: string;
  fecha_recepcion: string;
  nombre_recep: string;
  paterno_recep: string;
  evaluacion: string;
  fecha_evaluacion: string;
  observacion_evaluacion: string;
  nombre_eval: string;
  paterno_eval: string;
  aprobacion: string;
  fecha_aprobacion: string;
  observacion_aprobacion: string;
  nombre_apro: string;
  paterno_apro: string;
  entrega: string;
  fecha_entrega: string;
  observacion_entrega: string;
  nombre_entrega: string;
  paterno_entrega: string;
}

interface TipoTramite {
  id: number;
  tipo: string;
  codigo_unidad: string;
  nombre_unidad: string;
  codigo_area: string;
  nombre_area: string;
  costo: number;
  costo_minedu: number;
}

interface Requisito {
  id: number;
  id_tipotramite: number;
  descripcion: string;
  completado: boolean;
}

interface Valorado {
  id: number;
  id_tipotramite: number;
  id_valorado: number;
  descripcion: string;
  costo: number;
  estado: string;
}

interface Deposito {
  id: number;
  id_tramite: number;
  nro_deposito: string;
  monto: number;
  fecha_deposito: string;
  cuenta: string;
}

interface CambioDeposito {
  id: number;
  id_tramite: number;
  id_deposito: number;
  id_valorado: number;
  monto: number;
  cantidad: number; // colo para servicio
  tipo: string; // 'valorado' | 'servicio' | 'valorado_multiple'
  numero?: string;
  numero_desde?: string;
  numero_hasta?: string;
}

export default {
  components: {
    BModal,
    BButton,
    BBadge
  },
  setup() {
    const route = useRoute();
    
    // Datos principales
    const tramite = ref<Tramite>({} as Tramite);
    const totales = ref<Totales>({} as Totales);
    const tipotramite = ref<TipoTramite>({} as TipoTramite);
    const loading = ref(true);
    
    // Listados
    const etapas = ref<Etapa[]>([]);
    const requisitos = ref<Requisito[]>([]);
    const valorados = ref<Valorado[]>([]);
    const depositos = ref<Deposito[]>([]);
    const cambiosDepositos = ref<CambioDeposito[]>([]);
    
    // Modales de Depósito
    const depositoModalVisible = ref(false);
    const isEditingDeposito = ref(false);
    const loadingDepositoForm = ref(false);
    const depositoErrors = ref<Record<string, string[]>>({});
    const resumenDerivacionVisible = ref(false);
    const erroresDerivacion = ref<string[]>([]);
    const authStore = useAuthStore();

    const depositoForm = ref({
      id: null as number | null,
      id_tramite: route.params.id,
      nro_deposito: '',
      monto: 0,
      fecha_deposito: '',
      destino: 'dde'
    });
    
    const userRoles = computed(() => {
      const roles = authStore.user?.roles || [];
      return roles.join(', ');
    });
     // Verificar si tiene rol distrital
    const hasDistritalRole = computed(() => {
      const roles = authStore.user?.roles || [];
      return roles.includes('Distrital');
    });
    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    // Modal de Cambio de Depósito
    const cambioDepositoModalVisible = ref(false);
    const loadingCambioDepositoForm = ref(false);
    const cambioDepositoErrors = ref<Record<string, string[]>>({});
    const depositoSeleccionado = ref<Deposito | null>(null);
    const series = ref(['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']);
    const loadingDetalle = ref(false);
    const cambioDepositoForm = ref({
      id_tramite: route.params.id,
      id_deposito: 0,
      id_valorado: 0,
      monto: 0,    
      cantidad: 1,
      tipo: 'valorado', // Valor por defecto
      serie: '',
      numero: '',
      numero_desde: '',
      numero_hasta: ''
    });
    // Computed para cálculos
    const totalCanjeado = computed(() => {
      return cambiosDepositos.value.reduce((sum, cambio) => sum + Number(cambio.monto), 0);
    });
    
    const saldoDeposito = computed(() => {
      return Number(totales.value.total_dep) - Number(totalCanjeado.value);
    });
    
    // Método para validar derivación
    const validarDerivacion = () => {
      erroresDerivacion.value = [];
      
      // Validar requisitos completos
      const requisitosIncompletos = requisitos.value.filter(r => !r.id_requisito);
      if (requisitosIncompletos.length > 0) {
        erroresDerivacion.value.push(
          `Faltan completar ${requisitosIncompletos.length} requisitos`
        );
      }
      
      // Validar montos depositados
      if (Number(totales.value.total_dep) < Number(totales.value.costo_total)) {
        erroresDerivacion.value.push(
          `El total depositado (${totales.value.total_dep}) es menor al costo total (${totales.value.costo_total})`
        );
      }

      // Validar montos canjeados
      if (Number(totalCanjeado.value) < Number(totales.value.costo_total)) {
        erroresDerivacion.value.push(
          `El total canjeado (${totalCanjeado.value}) es menor al costo total (${totales.value.costo_total})`
        );
      }
      
      // Validar saldo positivo
      if (saldoDeposito.value < 0) {
        erroresDerivacion.value.push(
          `El total canjeado (${totalCanjeado.value}) supera el total depositado (${totales.value.total_dep})`
        );
      }
      
      // Validar montos canjeados vs costos
      let costoTotalCanje = 0;
      cambiosDepositos.value.forEach(cambio => {
        if (cambio.id_valorado) {
          const valorado = valorados.value.find(v => v.id_valorado === cambio.id_valorado);
          if (valorado && Number(cambio.monto) < Number(valorado.costo)) {
            erroresDerivacion.value.push(
              `El canje para ${valorado.descripcion} (${cambio.monto}) es menor al costo requerido (${valorado.costo})`
            );
          }
        }
      });
    };

    const cargarDetalleValorado = async () => {
      if (!cambioDepositoForm.value.id_valorado) return;
      
      loadingDetalle.value = true;
      try {
        const response = await axios.get(`/valorado/detalle/${cambioDepositoForm.value.id_valorado}`);
        // cambioDepositoForm.value.monto = response.data.monto;
        cambioDepositoForm.value.cantidad = response.data.cantidad || 1;
        cambioDepositoForm.value.monto = response.data.item.costo;
        cambioDepositoForm.value.serie = response.data.item.serie;
        cambioDepositoForm.value.numero = response.data.item.numero;
        cambioDepositoForm.value.numero_desde = response.data.item.numero;
      } catch (error) {
        console.error('Error al cargar detalle del valorado:', error);
      } finally {
        loadingDetalle.value = false;
      }
    };
    
    const handleTipoChange = () => {
      // Limpiar campos relacionados cuando cambia el tipo
      cambioDepositoForm.value.id_valorado = '';
      cambioDepositoForm.value.serie = '';
      cambioDepositoForm.value.cantidad = 1;
      cambioDepositoForm.value.numero = '';
      cambioDepositoForm.value.numero_desde = '';
      cambioDepositoForm.value.numero_hasta = '';
    };
    
    // Computed properties
    const depositoModalTitle = computed(() => {
      return isEditingDeposito.value ? 'Editar Depósito' : 'Nuevo Depósito';
    });
    
    const totalValorados = computed(() => {
      return valorados.value.reduce((sum, valorado) => sum + valorado.costo, 0);
    });
    
    const costoTotal = computed(() => {
      return (Number(tipotramite.value.costo) || 0) + 
             (Number(tipotramite.value.costo_minedu) || 0) + 
             Number(totalValorados.value);
    });
    
    const totalDepositos = computed(() => {
      return depositos.value.reduce((sum, deposito) => sum + Number(deposito.monto), 0);
    });

    const montoRestante = computed(() => {
      return Number(costoTotal.value) - Number(totalDepositos.value);
    });
    
    // Métodos
    const formatDate = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES');
    };
    
    const fetchTramite = async () => {
      try {
        const response = await axios.get(`/tramite/edit/${route.params.id}`);
        tramite.value = response.data.tramite;
        await fetchTipoTramite(tramite.value.id_tipo_tramite);
      } catch (error) {
        console.error('Error al cargar el trámite:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la información del trámite'
        });
      } finally {
        loading.value = false;
      }
    };

    const fetchTotales = async () => {
      try {
        const response = await axios.get(`/tramite/costototal/${route.params.id}`);
        totales.value = response.data.totales;
      } catch (error) {
        console.error('Error al cargar totales del trámite:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la información de totales del trámite'
        });
      } finally {
        loading.value = false;
      }
    };
    
    const fetchTipoTramite = async (id: number) => {
      try {
        const response = await axios.get(`/tipotramite/edit/${id}`);
        tipotramite.value = response.data.tipotramite;
      } catch (error) {
        console.error('Error al cargar el tipo de trámite:', error);
      }
    };
    
    const fetchEtapasTramites = async () => {
      try {
        const response = await axios.get(`/tramite/etapa/${route.params.id}`);
        etapas.value = response.data.etapa_tramite;
      } catch (error) {
        console.error('Error al cargar etapas:', error);
      }
    };

    const fetchRequisitos = async () => {
      try {
        const response = await axios.get(`/tramite/requisitolist/${route.params.id}`);
        requisitos.value = response.data.requisitos;
      } catch (error) {
        console.error('Error al cargar requisitos:', error);
      }
    };
    
    const fetchValorados = async () => {
      try {
        const response = await axios.get(`/tramite/valoradolist/${tramite.value.id_tipo_tramite}`);
        valorados.value = response.data.valorados;
      } catch (error) {
        console.error('Error al cargar valorados:', error);
      }
    };
    
    const fetchDepositos = async () => {
      try {
        const response = await axios.get(`/tramitedeposito/list/${route.params.id}`);
        depositos.value = response.data.depositos;
      } catch (error) {
        console.error('Error al cargar depósitos:', error);
      }
    };
    
    const fetchCambiosDepositos = async () => {
      try {
        const response = await axios.get(`/tramitedeposito/canjelist/${route.params.id}`);
        cambiosDepositos.value = response.data.cambios;
      } catch (error) {
        console.error('Error al cargar cambios de depósito:', error);
      }
    };
    
    const getValoradoName = (id: number) => {
      const valorado = valorados.value.find(v => v.id_valorado === id);
      return valorado ? valorado.descripcion : 'Desconocido';
    };
    
    const showDepositoModal = (deposito: Deposito | null) => {
      depositoErrors.value = {};
      if (deposito) {
        isEditingDeposito.value = true;
        depositoForm.value = {
          id: deposito.id,
          id_tramite: deposito.id_tramite,
          nro_deposito: deposito.nro_deposito,
          monto: deposito.monto,
          fecha_deposito: deposito.fecha_deposito,
          destino: deposito.destino
        };
      } else {
        isEditingDeposito.value = false;
        depositoForm.value = {
          id: null,
          id_tramite: route.params.id,
          nro_deposito: '',
          monto: 0,
          fecha_deposito: new Date().toISOString().split('T')[0],
          destino: 'dde'
        };
      }
      depositoModalVisible.value = true;
    };
    
    const showCambioDepositoModal = (deposito: Deposito) => {
      cambioDepositoErrors.value = {};
      depositoSeleccionado.value = deposito;
      cambioDepositoForm.value = {
        id_tramite: route.params.id,
        id_deposito: deposito.id,
        id_valorado: 0,
        tipo: 'valorado',
        monto: 0,
        cantidad: 1,
        serie: '',
        numero: '',
        numero_desde: '',
        numero_hasta: ''
      };
      cambioDepositoModalVisible.value = true;
    };
    
    const handleDepositoSubmit = async () => {
      loadingDepositoForm.value = true;
      depositoErrors.value = {};
      
      try {
        let response;
        
        if (isEditingDeposito.value && depositoForm.value.id) {
          response = await axios.post(`/tramitedeposito/update/${depositoForm.value.id}`, depositoForm.value);
        } else {
          response = await axios.post('/tramitedeposito/create', depositoForm.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        depositoModalVisible.value = false;
        await fetchDepositos();
        await fetchTotales();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          depositoErrors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingDepositoForm.value = false;
      }
    };
    
    const handleCambioDepositoSubmit = async () => {
      const datos = {
        id_tramite: cambioDepositoForm.value.id_tramite,
        id_deposito: cambioDepositoForm.value.id_deposito,
        monto: cambioDepositoForm.value.monto,
        tipo: cambioDepositoForm.value.tipo
      };

      if (cambioDepositoForm.value.tipo === 'valorado') {
        datos.id_valorado = cambioDepositoForm.value.id_valorado;
        datos.numero = cambioDepositoForm.value.numero;
        datos.serie = cambioDepositoForm.value.serie;
      } else if (cambioDepositoForm.value.tipo === 'valorado_multiple') {
        datos.id_valorado = cambioDepositoForm.value.id_valorado;
        datos.serie = cambioDepositoForm.value.serie;
        datos.numero_desde = cambioDepositoForm.value.numero_desde;
        datos.numero_hasta = cambioDepositoForm.value.numero_hasta;
      } else if (cambioDepositoForm.value.tipo === 'servicio') {
        datos.cantidad = cambioDepositoForm.value.cantidad;
      }
      loadingCambioDepositoForm.value = true;
      cambioDepositoErrors.value = {};
      try {
        const response = await axios.post('/tramitedeposito/canjesave', datos);
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        cambioDepositoModalVisible.value = false;
        await fetchCambiosDepositos();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          cambioDepositoErrors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingCambioDepositoForm.value = false;
      }
      fetchDepositos();
    };
    
    const marcarRequisito = async (idRequisito: number) => {
      try {
        await axios.post('/tramite/recibirequisito', {
          id_tramite: route.params.id,
          id_requisito: idRequisito
        });
        
        Swal.fire({
          icon: 'success',
          title: 'Requisito marcado',
          text: 'El requisito ha sido marcado como completado'
        });
        
        await fetchRequisitos();
      } catch (error) {
        console.error('Error al marcar requisito:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo marcar el requisito'
        });
      }
    };
    const eliminarRequisito = async (idRequisito: number) => {
      try {
        await axios.post('/tramite/eliminarequisito', {
          id_tramite: route.params.id,
          id_requisito: idRequisito
        });
        
        Swal.fire({
          icon: 'success',
          title: 'Requisito Eliminado',
          text: 'El requisito ha sido eliminado'
        });
        
        await fetchRequisitos();
      } catch (error) {
        console.error('Error al marcar requisito:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo marcar el requisito'
        });
      }
    };
    // Modificar derivarTramite para mostrar el modal
    const derivarTramite = async (idTramite: number) => {
      await Promise.all([
        fetchEtapasTramites(),
        fetchRequisitos(),
        fetchDepositos(),
        fetchCambiosDepositos(),
        fetchTotales(),
      ]);
      validarDerivacion();
      resumenDerivacionVisible.value = true;
    };
    const generateFormPDF = (id: number) => {
      axios.get(`/tramite/reporte/${id}`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        // Crear el blob
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        // Abrir en nueva pestaña en lugar de descargar
        window.open(url, '_blank');
        
        // Limpiar después de un tiempo (opcional)
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);
        
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    // Confirmar derivación
    const confirmarDerivacion = async () => {
      if (erroresDerivacion.value.length > 0) return;
      
      try {
        await axios.get(`/tramite/derivar/${tramite.value.id}`);
        Swal.fire({
          icon: 'success',
          title: 'Trámite Derivado',
          text: 'El trámite ha sido derivado correctamente'
        });
        resumenDerivacionVisible.value = false;
        await fetchTramite();
      } catch (error) {
        console.error('Error al derivar trámite:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo derivar el trámite'
        });
      }
      fetchEtapasTramites();
    };

    const confirmarDerivacionVenta = async () => {
      try {
        await axios.get(`/tramite/derivar/${tramite.value.id}`);
        Swal.fire({
          icon: 'success',
          title: 'Trámite Derivado',
          text: 'El trámite ha sido derivado correctamente'
        });
        resumenDerivacionVisible.value = false;
        await fetchTramite();
      } catch (error) {
        console.error('Error al derivar trámite:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo derivar el trámite'
        });
      }
      fetchEtapasTramites();
    };

    const derivarTramiteAAA = async (idTramite: number) => {
      try {
        await axios.get(`/tramite/derivar/${idTramite}`);
        
        Swal.fire({
          icon: 'success',
          title: 'Derivar Tramite',
          text: 'El Tramite ha sido derivado a la Unidad Organizacional y seccion correspondiente'
        });
        
        await fetchTramite();
      } catch (error) {
        console.error('Error al derivar el tramite:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo derivar el tramite'
        });
      }
    };
    
    const confirmDeleteDeposito = (deposito: Deposito) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar este depósito?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteDeposito(deposito.id);
        }
      });
    };
    
    const deleteDeposito = async (id: number) => {
      try {
        await axios.get(`/tramitedeposito/delete/${id}`);
        
        Swal.fire({
          icon: 'success',
          title: 'Depósito eliminado',
          text: 'El depósito ha sido eliminado correctamente'
        });
        
        await fetchDepositos();
        await fetchCambiosDepositos();
      } catch (error) {
        console.error('Error al eliminar depósito:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo eliminar el depósito'
        });
      }
    };

    const confirmDeleteDepositoCambio = (cambio: CambioDeposito) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar este depósito?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteDepositoCambio(cambio.id);
        }
      });
    };

    const deleteDepositoCambio = async (id: number) => {
      try {
        await axios.get(`/tramitedeposito/canjedelete/${id}`);
        
        Swal.fire({
          icon: 'success',
          title: 'Canje eliminado',
          text: 'El Canje del depósito ha sido eliminado correctamente'
        });
        
        await fetchDepositos();
        await fetchCambiosDepositos();
      } catch (error) {
        console.error('Error al eliminar depósito:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo eliminar el depósito'
        });
      }
    };
    const ShowButton = computed(() => {
      const userRoles = authStore.user?.roles || [];
      const hasDistritalRole = userRoles.includes('Distrital');
      const hasVentanillaRole = userRoles.includes('ventanilla');
      
      return (
        (hasDistritalRole && tramite.value.recepcion === 'Recepcionado') ||
        (hasVentanillaRole && tramite.value.recepcion === 'Recibido')
      );
    });
    onMounted(() => {
      fetchTramite().then(() => {
        fetchRequisitos();
        fetchValorados();
        fetchDepositos();
        fetchCambiosDepositos();
        fetchTotales();
        fetchEtapasTramites();
      });
    });
    
    return {
      tramite,
      tipotramite,
      loading,
      etapas,
      requisitos,
      valorados,
      depositos,
      cambiosDepositos,
      depositoModalVisible,
      handleTipoChange,
      isEditingDeposito,
      depositoForm,
      depositoErrors,
      loadingDepositoForm,
      cambioDepositoModalVisible,
      cambioDepositoForm,
      cambioDepositoErrors,
      loadingCambioDepositoForm,
      depositoSeleccionado,
      depositoModalTitle,
      totalValorados,
      costoTotal,
      totales,
      totalDepositos,
      montoRestante,
      formatDate,
      showDepositoModal,
      showCambioDepositoModal,
      handleDepositoSubmit,
      handleCambioDepositoSubmit,
      marcarRequisito,
      eliminarRequisito,
      generateFormPDF,
      derivarTramite,
      confirmDeleteDeposito,
      confirmDeleteDepositoCambio,
      getValoradoName,
      cargarDetalleValorado,
      userRoles,
      hasDistritalRole,
      hasPermission,
      ShowButton,
      series,
      loadingDetalle,
      resumenDerivacionVisible,
      erroresDerivacion,
      totalCanjeado,
      saldoDeposito,
      confirmarDerivacion,
      confirmarDerivacionVenta
    };
  }
};
</script>

<style scoped>
  .card-header {
    background-color: #f8f9fa;
  }
  
  .table th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
    padding: 0.5em;
    margin: 0;
  }
  .table td {
    top: 0;
    padding: 0.5em;
    margin: 0;
  }
  .btn-round {
    border-radius: 50px;
  }
  
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
  
  .alert {
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
  }
  
  .alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
  
  .alert-warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }
  
  .alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
</style>